import type { AccumulatorType } from './AccumulatorsUserContractBalanceSchema'
import type { OperationType } from './AccumulatorsUserContractSchema'

export type ReportOperationSchema = {
  id: number
  pay_period_id: number
  type: OperationType
  effective_at: string
  description?: string
  bonified_amount_in_minutes?: number
  unbonified_amount_in_minutes?: number
  manual_entry?: boolean
  percentage: number
}

export type AccumulatorSchema = {
  id: number
  membership_id: number
  user_contract_id: number
  type: AccumulatorType
  avatar_url?: string
  balance_after: number
  effective_date: string
  employee_name: string
  operations?: ReportOperationSchema[]

  // Only for RCR
  balance_before?: number
  planned_balance?: number
  total_rcr_deposits?: number
  is_part_time?: boolean
}

export type LocationRcrOptions = {
  allow_negative_balance: boolean
  enable_compensatory_for_part_time: boolean
  skip_percentage_bonification: boolean
}

export type AccumulatorsReportSchema = {
  accumulators: AccumulatorSchema[]
  total: number
  updated_by: string
  updated_at: string

  // Only for RCR
  location_rcr_options?: LocationRcrOptions
}

export const BALANCE_TYPE = {
  DAYS: 'days',
  HOURS: 'hours'
} as const

export type BalanceType = (typeof BALANCE_TYPE)[keyof typeof BALANCE_TYPE]
